import { Component, type ErrorInfo, type ReactNode } from 'react';
import ErrorImage from '@/shared/ui/images/ErrorImage.svg?react';
import styles from './ErrorBoundary.module.less';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[render]', error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className={styles.page}>
        <ErrorImage className={styles.image} />
        <p className={styles.title}>Что-то пошло не так</p>
        <p className={styles.subtitle}>
          Приложение не смогло открыть этот экран
        </p>
        <button
          type="button"
          className={styles.btn}
          onClick={() => window.location.reload()}
        >
          Перезагрузить
        </button>
      </div>
    );
  }
}
